module.exports = __webpack_public_path__ + "img/filipbasara_gabee_interface_mock.bea361e2.jpg";